@for (m of this.botMessagesService.getMessages(); track m; let i = $index) {
@let msg = m.content.at(0);
@if (!m.bypass && msg && msg.type === 'text' && msg.text.trim() !== '') {
<div
  class="message-row message-row-{{m.role}}"
  [class.quiz-buttons]="getCardCssClass(m) === 'quiz-buttons'"
  [class.quiz-row]="isQuizQuestion(i)"
>
  @if (m.role === 'botcard') {
  <app-message-card
    [message]="m"
    [isLast]="this.isLastVisibleMessage(i)"
    [enableDeletion]="this.botConfig().messageDeleteChatActive && this.enableDeletionOverride()"
    (deleteMessage)="this.deleteMessage($event)"
  ></app-message-card>
  }
  @if (m.role !== 'botcard') {
  <app-message-bubble
    [message]="m"
    [bot]="this.botConfig()"
    [botChatMsgSourceOption]="this.botConfig().chatMsgSourceOption"
    [voiceOutputActive]="this.botConfig().voiceOutputChatActive"
    [annotations]="this.annotations()"
    [enableFeedback]="this.botConfig().enableMessageFeedback && enableFeedbackOverride()"
    [enableDeletion]="this.botConfig().messageDeleteChatActive && this.enableDeletionOverride()"
    [isThinking]="this.isThinking() && i === this.botMessagesService.getMessageCount() - 1"
    [remark]="this.msgIdToFeedbackMap.get(m._id)?.remark ?? ''"
    [debugMode]="this.debugMode()"
    (sendFeedback)="this.sendFeedback($event)"
    (deleteMessage)="this.deleteMessage($event)"
  ></app-message-bubble>
  }
</div>
}
@if (msg && msg.type === 'mcp_approval_request') {
<app-message-mcp-approval-request
  class="d-block"
  [message]="m"
  [botConfig]="this.botConfig()"
></app-message-mcp-approval-request>
}
}

@if (this.isThinking()) {
<app-thinking-animation
  [botConfig]="this.botConfig()"
  [message]="this.getLoadingMessage()"
>
</app-thinking-animation>
}

<div
  id="scrollAnker"
  style="height: 30px;"
></div>